export const getMoneyLabel = (value?: string): {label: string; isMissing: boolean} => {
    const normalizedValue = value?.trim() || ''

    return normalizedValue
        ? {label: `${normalizedValue} ₽ за смену`, isMissing: false}
        : {label: 'Стоимость не указана', isMissing: true}
}
